import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M4.29289 15.2929L15.2929 4.29289C15.6534 3.93241 16.2206 3.90468 16.6129 4.2097L16.7071 4.29289L19.7071 7.29289C20.0676 7.65338 20.0953 8.22061 19.7903 8.6129L19.7071 8.70711L8.70711 19.7071C8.55083 19.8634 8.34815 19.9626 8.13144 19.9913L8 20H5C4.48716 20 4.06449 19.614 4.00673 19.1166L4 19V16C4 15.779 4.07316 15.5655 4.20608 15.392L4.29289 15.2929L15.2929 4.29289L4.29289 15.2929Z" />,
  'Pen'
);
